import React, { useState, useEffect } from 'react';
import { Card, Tooltip } from "antd";
import MetadataLogo from "../images/MetadataCardLogo.png";
import L7Logo from "../images/L7Logo.png";
import './CardPageStyles.less';
import { checkPNNLStaff } from './ScientiaProducts';

interface LimsAppsProps {
    onExternalLinkClick: (url: string, e: React.MouseEvent<HTMLAnchorElement>) => void;
    currentUser: any;
}

const LimsApps: React.FC<LimsAppsProps> = ({onExternalLinkClick, currentUser}) => {
    const [isPNNLStaff, setIsPNNLStaff] = useState<boolean>(false);

    const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onExternalLinkClick(url, e);
    };

    const handleOpenMetadata = (e: any) => {
        handleExternalLinkClick(process.env.REACT_APP_METADATA as string, e);
    }

    const handleOpenL7 = (e: any) => {
        // commenting the approach to open url in an iframe and opening in a new tab, as there are few security issues to be addressed.
        // handleExternalLinkClick(process.env.REACT_APP_LIMS as string, e);
        window.open(process.env.REACT_APP_LIMS, '_blank');
    }

    const handleOpenAllCards = (e: any) => {
        handleExternalLinkClick('ALL_CARDS', e) 
    }

    useEffect(() => {
        setIsPNNLStaff(checkPNNLStaff(currentUser));
    }, [currentUser]);

    return (
        isPNNLStaff ? (
            <div className="product-brief-intro">
                <div className="title-wrapper">
                    <div className="crumbs">
                        <a href="#" onClick={handleOpenAllCards}>All Modules</a> &gt; LIMS
                    </div><br />
                    <div className="platform-title">LIMS</div><br />
                    <div className="platform-subtitle">Laboratory Information Management System.</div>
                    <span style={{ display: 'block', height: '20px' }} />
                </div>
                <div className="card-container">
                    <Tooltip
                        title="Allows you to submit sample metadata and track shipment status."
                        overlayInnerStyle={{color: 'black'}}
                        color="white"
                        placement="bottom"
                    >
                        <Card 
                            className="app-card"
                            hoverable
                            onClick={handleOpenMetadata}
                            cover={<img src={MetadataLogo} alt="metadata-logo"/>}
                        >
                            <div>
                                <h2 className="title">
                                    Sample Submission
                                </h2>
                                <p className="subtitle">
                                    Sample information and shipment status.
                                </p>
                            </div>
                        </Card>
                    </Tooltip>
                    <Tooltip
                        title="Easy, secure and scaleable way to manage and integrate with laboratory systems to protect project workflow and data."
                        overlayInnerStyle={{color: 'black'}}
                        color="white"
                        placement="bottom"
                    >
                        <Card 
                            className="app-card"
                            hoverable
                            onClick={handleOpenL7}
                            cover={<img src={L7Logo} alt="l7-logo"/>}
                        >
                            <div>
                                <h2 className="title">
                                    L7
                                </h2>
                                <p className="subtitle">
                                    Enterprise Science Platform
                                </p>
                            </div>
                        </Card>
                    </Tooltip>
                </div>
            </div>
        ) : (
            <iframe
                src={process.env.REACT_APP_METADATA}
                title="External Page"
                style={{ width: '100%', height: 'calc(100vh - 84px)', backgroundColor: '#fff' }}
            />
        )
    );
  };
  
  export default LimsApps;
  